import { LOGO_BASE64, LOGO_WIDTH, LOGO_HEIGHT } from './logoBase64';

/**
 * Adiciona o header com logo do Projeto DOM em um documento jsPDF.
 * A logo ocupa 1/4 da largura da página no canto superior esquerdo.
 * Retorna o Y onde o conteúdo deve começar após o header.
 */
export const addPdfHeader = (doc) => {
  const pageWidth = doc.internal.pageSize.getWidth();
  const logoWidth = pageWidth / 4;
  const logoHeight = logoWidth * (LOGO_HEIGHT / LOGO_WIDTH);
  const margin = 10;

  doc.addImage(LOGO_BASE64, 'JPEG', margin, margin, logoWidth, logoHeight);

  // Retorna Y após a logo + espaçamento
  return margin + logoHeight + 5;
};

/**
 * Retorna o margin top que o autoTable deve usar para não sobrepor a logo nas páginas seguintes.
 */
export const getPdfHeaderHeight = (doc) => {
  const pageWidth = doc.internal.pageSize.getWidth();
  const logoWidth = pageWidth / 4;
  const logoHeight = logoWidth * (LOGO_HEIGHT / LOGO_WIDTH);
  return 10 + logoHeight + 5;
};

/**
 * Adiciona header em todas as páginas do documento.
 * Chamar APÓS todo o conteúdo ser adicionado.
 */
export const addPdfHeaderAllPages = (doc) => {
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    addPdfHeader(doc);
  }
};
